<template>
    <div>
        <v-row
            v-if="cartStatus === 'unloaded' || cartStatus === 'loading'"
            class="row-cart-empty"
        >
            <v-col>
                <div
                    class="d-flex flex-column align-center justify-center"
                >
                    <h4
                        class="text-h4 mb-4"
                    >
                        Loading Cart
                    </h4>
                    <v-progress-circular
                        width="3"
                        size="32"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </div>
            </v-col>
        </v-row>
        <v-row
            v-else-if="cartStatus === 'loaded' || cartStatus === 'working'"
            :dense="isMobile"
        >
            <!-- Cart Contents -->
            <v-col
                cols="12"
                md="8"
            >
                <CartList></CartList>
            </v-col>

            <!-- Cart Totals -->
            <v-col
                cols="12"
                md="4"
            >
                <v-row>
                    <v-col>
                        <CartPriceAdjustment
                            @on-error="onCartPriceAdjustmentError"
                        ></CartPriceAdjustment>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-sheet
                            class="border border-opacity-25 rounded pa-2 d-flex flex-column"
                        >
                            <CartTotals></CartTotals>

                            <div
                                class="d-flex flex-column"
                            >
                                <v-row
                                    class="fill-width ma-0"
                                >
                                    <v-col
                                        v-if="cartObj"
                                        class="px-1"
                                    >
                                        <v-btn
                                            to="/checkout"
                                            variant="flat"
                                            color="primary"
                                            :disabled="!canCheckout"
                                            size="large"
                                            block
                                            nuxt
                                        >
                                            Continue to Checkout
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            v-else
            class="row-cart-empty"
        >
            <v-col>
                <div
                    class="d-flex flex-column align-center justify-center"
                >
                    <h4
                        class="text-h4 mb-4"
                    >
                        Your cart is empty
                    </h4>
                    <NuxtLink
                        to="/"
                    >
                        Back to Home
                    </NuxtLink>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts" setup>
    import {
        useCarts,
        useIsMobile
    } from '~/composables';
    import { useGlobalAlert } from 'x1-base/composables';
    import type { NuxtError } from '#app';
    // import CartList from '~/components/cart/CartList/CartList.vue';
    // import CartTotals from '~/components/cart/CartTotals/CartTotals.vue';
    // import CartPriceAdjustment from '~/components/cart/CartPriceAdjustment/CartPriceAdjustment.vue';

    const CartList = defineAsyncComponent(() => import('~/components/cart/CartList/CartList.vue'));
    const CartTotals = defineAsyncComponent(() => import('~/components/cart/CartTotals/CartTotals.vue'));
    const CartPriceAdjustment = defineAsyncComponent(() => import('~/components/cart/CartPriceAdjustment/CartPriceAdjustment.vue'));

    const {
        cartObj,
        cartStatus,
        canCheckout
    } = useCarts();
    const { isMobile } = useIsMobile();
    const createGlobalAlert = useGlobalAlert();

    function onCartPriceAdjustmentError([ ctx, error ]: [string, NuxtError]): void {
        switch (ctx) {
            case 'transfer':
                createGlobalAlert({
                    text: 'Unable to perform account balance transfer. Please try again later.',
                    show: true,
                    type: 'error'
                });
                break;
            case 'credit':
                createGlobalAlert({
                    text: 'Unable to apply/unapply credit. Please try again later.',
                    show: true,
                    type: 'error'
                });
                break;
        }
    }
</script>

<style lang="scss" scoped>
.row-cart-empty {
    min-height: 400px;
}
</style>
